import React from "react";
import { FormattedMessage as FM } from "react-intl";
import { Marker, Popup, Tooltip } from "react-leaflet";
import { NavLink } from "react-router-dom";
import { Container, Header } from "semantic-ui-react";

import IPlacement from "../../../../data/priest/Placement";
import greenMarker from "../../../../util/mapMarkers/greenMarker";
import DateDisplay from "../../../DateDisplay";

interface IAssistantPriestPlaceMarkerProps {
    placement: IPlacement;
}

const AssistantPriestPlaceMarker: React.FC<IAssistantPriestPlaceMarkerProps> = (props: IAssistantPriestPlaceMarkerProps) => {
    const { placement } = props;

    return (
        <Marker icon={greenMarker} key={placement.ID} position={[placement.coordinates.lat || 0, placement.coordinates.lng || 0]}>
            <Popup>
                <Header as="h2" className="hoverLink">
                    <NavLink to={`/parishes/profile/${placement.placeID}`}>{placement.place}</NavLink>
                </Header>
                <Container>
                    <div>
                        <FM id="profile.assistantPriestPlace" />
                    </div>
                    <div>
                        <FM id="profile.startDate" />: <DateDisplay date={placement.startDate} />
                    </div>
                    <div>
                        <FM id="profile.endDate" />: <DateDisplay date={placement.endDate} />
                    </div>
                </Container>
            </Popup>
            <Tooltip>{placement.place}</Tooltip>
        </Marker>
    );
};

export default AssistantPriestPlaceMarker;
